export class Accordeon {
  constructor() {

    $('.aky-faq--trigger').click(function () {

      if($(this).hasClass('active')) {

        $('.active').removeClass('active');
        $('.open').removeClass('open');

      }
      else {

        $('.active').removeClass('active');
        $('.open').removeClass('open');

        let id = $(this).data('id');

        $('.' + id).toggleClass('active');
        //$(this).toggleClass('active');

        $('#' + id).toggleClass('open');
      }

    });

  }
}



// WEBPACK FOOTER //
// ./js/util/accordeon.js